<template>
  <div class="hello">

    <div class="container">
     <div class="item">

        <a href="https://www.visity.app/" target="_blank" class="logo">
          <img id="image" src="/static/img/visity1.png" width="40%">
        </a>

        <template v-if="showSignUpText">
          <p id="title">Business Sign Up</p>
          <!-- <p>It'll take 30 seconds. Yeah, we measured it.</p> -->
          <p>It's FREE, and we are confident you'll love it!!</p>
          <br>          
        </template>

 
        <!-- ----------------- Sign Up Form ----------------- -->

        <form class="SignUpForm" @submit.prevent="SendOTP" v-if="showForm">

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">My name is <b>*</b></label>
            <input type="text" class="form-control" v-model="FormInfo.ContactPerson" placeholder="First Name Last Name" required>
          </div>

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">I work for <b>*</b></label>
            <input type="text" class="form-control" v-model="FormInfo.CompanyName" placeholder="Company Name" required>
          </div>

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">I am the <b>*</b></label>
            <input type="text" class="form-control" v-model="FormInfo.Designation" placeholder="Office Manager / CEO / etc" required>
          </div>

              <div class="form-group col-md-12">
                <label for="exampleInputEmail1">Country Code <b>*</b></label>
                  <select class="form-control" v-model="FormInfo.CountryCode" required @change="SelectCountryCode()">
                    <option value="+1">USA (+1)</option>
                    <option value="+91">India (+91)</option>
                  </select>
              <small id="passwordHelpBlock" class="form-text text-muted">
                Location. Location. Location.
              </small>             
              </div>


          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Mobile <b>*</b></label>
            <input type="tel" class="form-control" v-model="FormInfo.Mobile" minlength="10" maxlength="10" placeholder="" required>
              <small id="passwordHelpBlock" class="form-text text-muted">
                Without country code. 10 digits. Will be used for administrator login, make sure it's legit :)
              </small>
          </div>

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Email <b>*</b></label>
            <input type="email" class="form-control" v-model="FormInfo.Email" required>
              <small id="passwordHelpBlock" class="form-text text-muted">
                To dispatch notifications, reports & update. Don't worry, we don't spam.
              </small>
          </div>

          <div class="form-group col-md-12 button">
            <input type="submit" value="Create Account" class="btn btn-primary btn-block" :disabled="!ValidMobile" />
            <br>
          </div>

        </form>


          <!-- ----------------- Enter OTP ----------------- -->

            <form class="Message SignUpForm" @submit.prevent="VerifyOTP" v-if="showOTP">

              <div class="form-group col-md-12">
                <label for="exampleInputEmail1"><VAR></VAR>Verification code has been dispatched. Check your phone... </label>
                <input type="tel" class="form-control EnterMobile" v-model="InputOTP" minlength="6" maxlength="6" placeholder="Enter 6 Digit Code" required>
              </div>

              <div class="form-group col-md-12 button">
                <input type="submit" value="Verify" class="btn btn-primary btn-block Next" />
              </div>

            </form>

          <!-- ----------------- Message Templates ----------------- -->

            <template v-if="showSpinner">
              <div class="Message">
                <p class="loadingText">Sit tight!<br>Conspiring with the universe...</p>
                <i class="fa fa-circle-o-notch fa-spin fa-4x fa-fw spinner"></i>
              </div>
            </template>

            <template v-if="showSpinner2">
              <div class="Message">
                <p class="loadingText">Finishing the paper work...</p>
                <i class="fa fa-circle-o-notch fa-spin fa-4x fa-fw spinner"></i>
              </div>
            </template>

            <template v-if="showErrorMsg">

              <div class="Message">
              <i class="fa fa-exclamation" aria-hidden="true"></i>
              
              <p class="errorText">Houston, we have a problem!</p>
              <p>Account with {{FormInfo.Mobile}} already exists.<br>
      
                <a href="https://client-login-visity.web.app" target="_blank" class="SignIn">Click Here</a> to Sign In or let's try an <span class="SignIn" @click="Next()">alternate number?</span>

              </p>                
              </div>

            </template>

            <template v-if="submitMessage == true">

              <div class="Message">

                    <i class="fa fa-check" aria-hidden="true"></i>

                    <p class="successText">
                      It's a Home Run!
                    </p>

                    <p class="successSubText">
                      Account has been created successfully. <br>
                      <a href="https://client-login-visity.web.app" target="_blank" class="SignIn">Click Here</a> to Login
                    </p>              

              </div>

            </template>


        <br>

     </div>


    </div>

    <!-- Footer -->

<!--     <span class="unsplash">Photo by <a href="https://unsplash.com/@youxventures?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText" class="link">You X Ventures</a> on <a href="https://unsplash.com/s/photos/office?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText" class="link">Unsplash</a></span> -->

  </div>
</template>

<script>

import { db } from '../main'
import firebase from 'firebase'
import moment from 'moment';
import Autocomplete from 'vuejs-auto-complete'
import axios from 'axios';

export default {
  name: 'HelloWorld',
  components: {
    Autocomplete,
  },  
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      applications: [],
      CountryCodeList: [
        {Code:"+1", name: "United State of America (+1)"},
        {Code:"+91", name: "India (+91)"}
      ],
      ValidMobile: true,
      show: false,
      showSignUpText: true,
      showForm: true,
      showOTP: false,
      showSpinner: false,
      showSpinner2: false,
      showErrorMsg: false,
      submitMessage: false,
      showButton: false,
      showStatus: false,
      submitLoader: false,
      showNotFound: false,
      statusMessage: "",
      showTable: false,
      CountryCode: "",
      CompanyId: "",
      GeneratedOTP: "",
      InputOTP: "",
      Timer: 4,
      LocationInfo: {},
      FormInfo: {
        CompanyName: "",
        ContactPerson: "",
        Designation: "",
        Mobile: "",
        Email: "",
        CountryCode: ""
      }
    }
  },
  mounted(){
    console.log("Visity Sign Up");


  },
  methods: {   
    SelectCountryCode(){
      // this.FormInfo.Mobile = this.FormInfo.CountryCode;
    },
    CheckMobileFormat(){
  
      this.FormInfo.Mobile = this.FormInfo.CountryCode+this.FormInfo.Mobile;
      console.log("Mobile with Country Code: "+this.FormInfo.Mobile);

      if(this.FormInfo.Mobile.includes("+")){
        this.ValidMobile = true;
      }else{
        console.log("Please Include Country Code");
        this.ValidMobile = false;
      }


    },
    SendOTP(){

        this.showSignUpText = false;

        this.showForm = false;
        this.showSpinner = true;

        console.log("--- Send OTP ---");
        console.log("Mobile: "+this.FormInfo.Mobile);

        this.FormInfo.Mobile = this.FormInfo.CountryCode+this.FormInfo.Mobile;
        console.log("Mobile with Country Code: "+this.FormInfo.Mobile);

        this.GeneratedOTP = Math.floor(100000 + Math. random() * 900000);
        console.log("OTP: ",this.GeneratedOTP);

        var sms = "Verification Code is "+this.OTP+" for Visity SignUp.";

        let data = {
          Mobile: this.FormInfo.Mobile,
          Code: this.GeneratedOTP
        };

        console.log("SMS Payload: "+JSON.stringify(data));

      if(this.FormInfo.Mobile.includes("+91")){

          axios.post("https://us-central1-visity-fcbd6.cloudfunctions.net/widgets", data).then((res) => {
            console.log("Send SMS Success: ",res);
            this.showSpinner = false;
            this.showOTP = true;
          }).catch((e) => {
            console.log("Send SMS Error: ",e);
          });

      }else{

          axios.post("https://us-central1-visity-fcbd6.cloudfunctions.net/widgets/send-otp-twilio", data).then((res) => {
            console.log("Send SMS Success: ",res);
            this.showSpinner = false;
            this.showOTP = true;
          }).catch((e) => {
            console.log("Send SMS Error: ",e);
          });

      }


    },
    VerifyOTP(){

      console.log("Entered OTP: "+this.InputOTP);

      if(this.InputOTP == this.GeneratedOTP){
        
        this.showOTP = false;
        this.showSpinner2 = true;
        this.CheckMobile();

      }else{
        alert("Incorrect OTP");
      }

    },
    CheckMobile(){

      console.log("Mobile: "+this.FormInfo.Mobile);

      // --- Check if Mobile already exists --------

      db.collection('Company')
        .where("Mobile","==",this.FormInfo.Mobile)
        .where("Active","==",true)
        .get()
        .then((snap) => {

          console.log("Count: "+snap.docs.length);


          if(snap.docs.length == 0){
            this.AddtoFirestore();
          }else{
            this.showSpinner2 = false;
            this.showErrorMsg = true;
          }

      })
      .catch((e) => {

          console.log('Error:', (e));

      });        

    },
    AddtoFirestore(){

      console.log("Form Submitted");
      console.log(this.FormInfo);

      // ---- Generate Invite Code ----
      var InviteCode = Math.floor(Math.random() * (999999 - 100000)) + 100000;
      this.FormInfo.InviteCode = InviteCode.toString();

      // --- Set Payload for Location ----------
      this.LocationInfo = this.FormInfo;

            // ---------------- Create Organization -----------------------

            console.log("Upload to DB Started");

            this.FormInfo.CreatedOn = moment().format();
            this.FormInfo.Active = true;
            this.FormInfo.Version = 2;
            this.FormInfo.VisitPurpose = [
              "Guest",
              "Meeting",
              "Delivery",
              "Repair & Services",
              "Emergency Services",
              "Other"
            ];

            console.log("Payload: "+JSON.stringify(this.FormInfo));

              db.collection("Company")
                .add(this.FormInfo)
                .then((res) => {
                  console.log(res);
                  console.log("Company Created Successfully");

                  console.log("CompanyId: "+res.id);
                  this.CompanyId = res.id;

                  this.CreateLocation();

                });     



    },
    CreateLocation(){

      console.log("Create Location...");


        this.LocationInfo.CompanyId = this.CompanyId;
        this.LocationInfo.Location = "Front Desk";
        this.LocationInfo.AccessType = "Admin";
        this.LocationInfo.CreatedOn = moment().format();
        this.LocationInfo.Active = true;
        this.LocationInfo.Parameters = {
          ApproveVisitor: false,
          VisitType: false,
          WhomToMeet: false
        };
        this.LocationInfo.VisitPurpose = [
          "Guest",
          "Meeting",
          "Delivery",
          "Repair & Services",
          "Emergency Services",
          "Other"
        ];

            console.log("Location Payload: "+JSON.stringify(this.LocationInfo));

              db.collection("Location")
                .add(this.LocationInfo)
                .then((res) => {
                  console.log(res);
                  console.log("Company Created Successfully");

                  console.log("CompanyId: "+res.id);
                  this.CompanyId = res.id;

                  this.showSpinner2 = false;
                  this.submitMessage = true;


                });     


    },
    Next(){
      console.log("Test");
      this.showErrorMsg = false;
      this.showForm = true;
      this.showSignUpText = true;      
    },
    SignIn(){
      console.log("Navigate to Sign In Page in new tab");
      window.open('client-login-visity.web.app', '_blank');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

  .container{
     display: flex;
     flex-direction: row;
     align-items: center;
     align-content: center;
     justify-content: center;
     /* height: 80%; */
     /* border: 1px solid red; */
  }

  .item{
     margin-top: 5em;
     margin-bottom: 5em;
     align-self: center;
     align-items: center;
     align-content: center;
     justify-content: center;
     border-radius: 2em;
     /*border: 1px solid red; */
     background-color: #ffffff;
     /*opacity: 0.9;*/
  }

  .item2{
     align-self: center;
     align-items: center;
     align-content: center;
     justify-content: center;
  }

  .SignUpForm{
    margin-top: 1em;
    text-align: left;
    margin-left: 2em;
    margin-right: 2em;
  }

  #image{
    margin-top: 3em;
  }

  #title{
   margin-top: 1em;
   font-weight: bold;
   font-size: 2em;
  }

  #footerMsg{
    font-size: 0.7em;
    font-style: italic;
  }

  #message{
    text-align: left;
    /* padding: em; */
  }

  .button{
    text-align: center;
  }

  .spinner{
    color: #3880ff;
  }

  .unsplash{
    color: #ffffff;
  }

  .logo{
    margin-bottom: 2em;
  }

  .unsplash .link{
    color: #ffffff;
  }

  .mobileInvalid{
    color: red;
  }

  input, select{
    border-radius: 0.5em;
  }

  .loadingText{
    font-size: 1.5em;
    color: #3880ff;
  }

  .fa-exclamation{
    font-size: 5em;
    color: red;
  }

  .errorText{
    font-size: 1.5em;
    color: red;
  }

  .errorSubText{
    font-size: 1em;
  }

  .fa-check{
    font-size: 5em;
    color: #1abc9c;
  }

  .successText{
    font-size: 1.5em;
    font-weight: bold;
    color: #1abc9c;
  }

  .successSubText{
    font-size: 1em;
  }

  .SignIn{
    color: #3880ff;
    cursor: pointer;
  }

  .Message{
    margin-top: 4em;
  }

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue